export default __webpack_public_path__ + "static/media/image1.57019743.png";